/**
 * How often each kind of data re-checks the server while its tab is visible (React Query pauses
 * interval polling in background tabs by default). Without these, a page only ever updated when
 * the user reloaded: a seller wouldn't see a sale land, a buyer wouldn't see a release confirm.
 */
export const POLL = {
  /** Money/state that another party can change right now: order status, disputes, offers. */
  live: 8_000,
  /** Lists the user is actively watching for changes: orders, offers, tickets, own listings. */
  list: 15_000,
  /** Public catalogue and slow-moving stats. */
  catalogue: 30_000,
} as const;
